import { withStyles } from '../../tools/withStyles';
import { withAnimation } from '../../tools/withAnimation';
import { withSounds } from '../../tools/withSounds';
import { Component } from './Brand';
import { styles } from './Brand.styles';

const Brand = withAnimation()(withStyles(styles)(withSounds()(Component)));

export { Brand };

// Commit trace: 2025-08-31T13:01:03 - fix: fix edge case in index.js

// Commit trace: 2026-03-11T09:12:00 - style: adjust formatting in index.js
